import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IndividualRelationshipGroupModel } from "../../models/individual-relationship-group-model";
import { RelationshipIndividualDto } from "@models/individuals/relationship-individual-dto";
import { RelationshipType, RelationshipTypeLabels } from "@models/relationships/relationship-type.enum";

type CellRendererParams = ICellRendererParams<RelationshipIndividualDto | IndividualRelationshipGroupModel>;
@Component({
  selector: 'app-ag-relationship-name-and-role-cell',
  standalone: true,
  imports: [],
  templateUrl: 'ag-relationship-name-and-role-cell.component.html',
  styleUrl: 'ag-relationship-name-and-role-cell.component.scss'
})
export class AgRelationshipNameAndRoleCellComponent implements ICellRendererAngularComp{
  @Input() fullName = '';
  @Input() roles: string[] = [];
  @Input() isResigned = false;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.fullName = params.data?.name ?? '';
    this.roles = this.getRoles(params.data)
    this.isResigned = params.data?.isResigned ?? false;
    return true;
  }

  getRoles(model: RelationshipIndividualDto | IndividualRelationshipGroupModel | undefined): string[] {
    if (!model) return [];

    const roles: RelationshipType[] = [];

    if ('type' in model) {
      roles.push(model.type);
    } else if ('types' in model) {
      roles.push(...model.types);
    }

    return roles.map((type) => RelationshipTypeLabels[type]);
  }
}
